import { Component, Input } from '@angular/core';
import { DestroyBase } from '../../../../../components/common/ng-destroy-base';
import { ProjectPicturesService } from '../../../services/projects-pictures.service';

/**
 * Infobar (sidebar) that displays and handles actions to add/remove project images
 */
@Component({
  selector: 'project-infobar-pictures',
  templateUrl: './project-infobar-pictures.component.html'
})
export class ProjectInfobarPictures extends DestroyBase {

  /**
   * Input property data.
   */
  @Input() data: any;

  /**
   * Required roles
   */
  requiredRoles = ['HasRole'];

  /**
   * Reflist name
   */
  reflistName = 'ref_project_imagetype';

  /**
   * Default new image type
   */
  defaultNewImageType = 0;

  /**
   * Constructor
   */
  constructor(public projectsPicturesService: ProjectPicturesService) { super(); }
}
